import { Controller } from "@hotwired/stimulus"
import Trix from "trix"

const MAX_PARENT_SEARCH_DEPTH = 5;

function csrfToken() {
  return document.querySelector("meta[name='csrf-token']")?.content
}

export default class extends Controller {

  addRow(event) {
    fetch(`/tables/${this.getID()}`, {
      method: 'PATCH',
      headers: { 'X-CSRF-Token': csrfToken(), 'Accept': 'application/json' },
      body: new URLSearchParams({ method: 'addRow' })
    }).then(r => r.json()).then(this.attachTable.bind(this))
  }

  addColumn(event) {
    fetch(`/tables/${this.getID()}`, {
      method: 'PATCH',
      headers: { 'X-CSRF-Token': csrfToken(), 'Accept': 'application/json' },
      body: new URLSearchParams({ method: 'addColumn' })
    }).then(r => r.json()).then(this.attachTable.bind(this))
  }

  removeRow(event) {
    fetch(`/tables/${this.getID()}`, {
      method: 'PATCH',
      headers: { 'X-CSRF-Token': csrfToken(), 'Accept': 'application/json' },
      body: new URLSearchParams({ method: 'removeRow' })
    }).then(r => r.json()).then(this.attachTable.bind(this))
  }

  removeColumn(event) {
    fetch(`/tables/${this.getID()}`, {
      method: 'PATCH',
      headers: { 'X-CSRF-Token': csrfToken(), 'Accept': 'application/json' },
      body: new URLSearchParams({ method: 'removeColumn' })
    }).then(r => r.json()).then(this.attachTable.bind(this))
  }

  updateCell(event) {
    fetch(`/tables/${this.getID()}`, {
      method: 'PATCH',
      headers: { 'X-CSRF-Token': csrfToken(), 'Accept': 'application/json' },
      body: new URLSearchParams({
        method: 'updateCell',
        cell: event.target.dataset.key,
        value: event.target.value
      })
    })
  }

  getID() {
    return this.data.get('id');
  }

  attachTable(tableAttachment) {
    let attachment = new Trix.Attachment(tableAttachment)
    var parent = this.element.parentNode;
    var editorNode = null;
    for (let i = 0; i < MAX_PARENT_SEARCH_DEPTH; i++) {
      editorNode = parent.querySelector('trix-editor');
      if (editorNode != null) {
        i = MAX_PARENT_SEARCH_DEPTH;
      } else {
        parent = parent.parentNode;
      }
    }
    editorNode.editor.insertAttachment(attachment)
  }
}
